import type { LocaleMessageBundle } from '../../types'

export const statisticsDateFilterMessages: LocaleMessageBundle = {
  vi: {
    'statisticsDateFilter.presets.all': 'Tất cả',
    'statisticsDateFilter.presets.today': 'Hôm nay',
    'statisticsDateFilter.presets.yesterday': 'Hôm qua',
    'statisticsDateFilter.presets.thisWeek': 'Tuần này',
    'statisticsDateFilter.presets.lastWeek': 'Tuần trước',
    'statisticsDateFilter.presets.thisMonth': 'Tháng này',
    'statisticsDateFilter.presets.lastMonth': 'Tháng trước',
    'statisticsDateFilter.presets.custom': 'Tùy chỉnh',
    'statisticsDateFilter.fields.dateRange': 'Từ ngày - đến ngày',
    'statisticsDateFilter.placeholders.preset': 'Chọn khoảng thời gian',
    'statisticsDateFilter.actions.cancel': 'Đóng',
    'statisticsDateFilter.actions.apply': 'Chọn',
  },
  en: {
    'statisticsDateFilter.presets.all': 'All',
    'statisticsDateFilter.presets.today': 'Today',
    'statisticsDateFilter.presets.yesterday': 'Yesterday',
    'statisticsDateFilter.presets.thisWeek': 'This week',
    'statisticsDateFilter.presets.lastWeek': 'Last week',
    'statisticsDateFilter.presets.thisMonth': 'This month',
    'statisticsDateFilter.presets.lastMonth': 'Last month',
    'statisticsDateFilter.presets.custom': 'Custom',
    'statisticsDateFilter.fields.dateRange': 'From date - to date',
    'statisticsDateFilter.placeholders.preset': 'Select a date range',
    'statisticsDateFilter.actions.cancel': 'Cancel',
    'statisticsDateFilter.actions.apply': 'Apply',
  },
}
